import { TypeCompiler } from '@sinclair/typebox/compiler';

import { JobSchema } from '../schema/job.schema';

export const JobValidator = TypeCompiler.Compile(JobSchema);
